import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
    Box,
    Button,
    Chip,
    Link,
    MenuItem,
    Rating,
    Select,
    Skeleton,
    Stack,
    Typography,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { BackArrowIcon, DotsIcon, ExportIcon } from '../../icons';
import { GlobalStyles } from '@mui/material';
import { useState } from 'react';
import { useEffect } from 'react';
import { fetchUniversitiesNames, fetchUniversityRatingList } from '../../api/universityApi';
import { useNotification } from '../../hooks/useNotification';
import UpdateRatingStatusModal from '../../components/University/Rating/UpdateRatingStatus';
import CommonTableFormat from '../../components/common/CommonTableFormat';
import CommonFilterTab from '../../components/common/CommonFilterTab';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setPaginationFiled } from '../../containers/pagination-container/reducer/paginationSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import Tooltip from '@mui/material/Tooltip';
import { IconButton } from '@mui/material';
import CommonDataTable from '../../components/common/CommonDataTable';
import { formatMultiQueryParams, jsonParserFormatter } from '../../utils/helperFunction';
import { defaultPaginationValues, filterTypeOptions, reviewStatusList, studentStatusList } from '../../utils/constant';
import { setFilterField } from '../../containers/filter-container/reducer/filterSlice';
const AdminUniversityRating = () => {
    const filterSlice = useSelector(state => state.filter?.filters)
    const LOCATION_FILTER = `filters:${window.location.pathname}`
    const dispatch = useDispatch()
    const [rows, setRows] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const navigate = useNavigate();
    const [selectedReview, setSelectedReview] = useState(null);
    const [updateStatusOpen, setUpdateStatusOpen] = useState(false);
    const [searchFilter, setSearchFilter] = React.useState({})
    const [rowCount, setRowCount] = useState(0);
    const [pageFilters, setPageFilters] = React.useState(defaultPaginationValues);
    const [isRender, setIsRender] = React.useState(false)
    const { showErrorNotification, } = useNotification()
    const [universitySuggestion,setUniversitySuggesion] = React.useState([])
    

    const handleFliterSliceChange = (values = {}, isReset = false) => {
        let isQuery = typeof values === "object" && Object.keys(values)?.length
        isQuery && dispatch(setFilterField({ pathname: LOCATION_FILTER, filters: JSON.stringify({ ...(isReset ? {} : pageFilters), ...defaultPaginationValues, ...values }) }))
    }

    const fetchDetails = () => {
        const multiFilter = formatMultiQueryParams(filterSlice[LOCATION_FILTER])
        fetchUniversityRatingList({ setRows, filterData: { ...searchFilter, ...multiFilter, isMultiFilter: true }, setRowCount })
            .then(res => {
                setLoading(false)
            }).catch(error => {
                showErrorNotification(error?.message)
            })
    }

        const fetchUniversitySuggestionList = () => {
        fetchUniversitiesNames((result)=>setUniversitySuggesion(result?.map(item=>({...item,value:item?.label}))))
        .catch(err=>console.log("error:---",err))
      }


    React.useEffect(() => {
        fetchDetails()
    }, [filterSlice[LOCATION_FILTER], isRender])

    // handle extra filter tabs changes
    React.useEffect(() => {
        if (pageFilters?.page) {
            handleFliterSliceChange({ page: 0 })
        } else {
            setIsRender(!isRender)
        }
    }, [searchFilter])

    // parse page filters
    React.useEffect(() => {
        const values = jsonParserFormatter(filterSlice[LOCATION_FILTER])
        setPageFilters(values)
    }, [filterSlice[LOCATION_FILTER]])

      // initial load
      React.useEffect(()=>{
        fetchUniversitySuggestionList()
      },[])

    // Status colors mapping
    const statusStyles = {
        approved: {
            text: '#1b5e20', // Dark green
            bg: '#c8e6c9',   // Light green
        },
        pending: {
            text: '#ff9800', // Orange
            bg: '#fff3e0',   // Light orange
        },
        rejected: {
            text: '#b71c1c', // Dark red
            bg: '#ffcdd2',   // Light red
        },
    };


    const columns = [
        {
            field: 'sNo',
            headerName: 'S. No.',
            width: 60,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => rows?.findIndex((r) => r.id === params.row.id) + 1,
        },
        {
            field: 'studentDetails',
            headerName: 'Student Name',
            flex: 2,
            minWidth: 280,
            filterColumnName: "userId.fullName",
            filterType: filterTypeOptions.string,
            renderCell: (params) => {
                const { img, studentDetails } = params.row;

                const getInitials = (fullName) => {
                    if (!fullName) return '';
                    const words = fullName.trim().split(' ').filter(Boolean);
                    if (words.length === 1) return words[0][0]?.toUpperCase() || '';
                    if (words.length === 2) return (words[0][0] + words[1][0]).toUpperCase();
                    return (words[0][0] + words[1][0] + words[2][0]).toUpperCase();
                };

                const stringToColor = (str) => {
                    let hash = 0;
                    for (let i = 0; i < str.length; i++) {
                        hash = str.charCodeAt(i) + ((hash << 5) - hash);
                    }
                    const c = (hash & 0x00ffffff).toString(16).toUpperCase();
                    return '#' + '00000'.substring(0, 6 - c.length) + c;
                };

                const bgColor = stringToColor(studentDetails || 'Course');

                return loading ? (
                    <Skeleton width={150} />
                ) : (
                    <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                        sx={{ cursor: 'pointer' }}
                    >
                        {img ? (
                            <Box
                                component="img"
                                src={img}
                                alt="logo"
                                sx={{
                                    width: 40,
                                    height: 40,
                                    padding: '5px',
                                    borderRadius: '50%',
                                    objectFit: 'contain',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                                    display: 'block',
                                    maxHeight: 60,
                                }}
                            />
                        ) : (
                            <Box
                                sx={{
                                    minWidth: 35,
                                    minHeight: 35,
                                    maxWidth: 35,
                                    maxHeight: 35,
                                    borderRadius: '50%',
                                    backgroundColor: bgColor,
                                    color: '#fff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 500,
                                    fontSize: '10px',
                                    textTransform: 'uppercase',
                                    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                                }}
                            >
                                {getInitials(studentDetails)}
                            </Box>
                        )}
                        {params.value}
                    </Box>
                );
            },
        },

        {
            field: 'phoneNumber',
            headerName: 'Phone Number',
            flex: 1.2,
            minWidth: 160,
            cellClassName: 'fw-bold',
            filterColumnName: "userId.phone",
            filterType: filterTypeOptions.string,
        },
        {
            field: 'emailID',
            headerName: 'Email ID',
            flex: 1,
            minWidth: 180,
            filterColumnName: "userId.email",
            filterType: filterTypeOptions.string,
        },
        {
            field: 'university',
            headerName: 'University',
            flex: 2,
            minWidth: 260,
            filterColumnName: "universityId.universityName",
            filterType: filterTypeOptions.selection,
            selection:universitySuggestion,
            renderCell: (params) => {
                const { universityName, } = params.row;
                return loading ? (
                    <Skeleton width={150} />
                ) : (
                    <Box display="flex" sx={{ height: '100%', flexDirection: 'column', justifyContent: 'center', }}>
                        {/* Course Name */}
                        <Typography
                            sx={{
                                fontSize: '11px !important',
                                fontWeight: 500,
                                color: '#6E7485',
                                paddingTop: '4px',
                            }}
                        >
                            {universityName}
                        </Typography>
                    </Box>
                );
            },
        },
        {
            field: 'rating',
            headerName: 'Rating',
            flex: 1.2,
            minWidth: 160,
            cellClassName: 'fw-bold',
            filterColumnName: "rate",
            filterType: filterTypeOptions.numberRange,
            renderCell: (params) => {
                const { rating, } = params.row;
                return loading ? (
                    <Skeleton width={150} />
                ) : (
                    <Box display="flex" sx={{ height: '100%', flexDirection: 'column', justifyContent: 'center', }}>
                        <Rating sx={{
                            color: '#FD8E1F', 
                        }} value={Math.floor(rating || 0)} readOnly size="small" />
                    </Box>
                );
            },
        },

        {
            field: 'review',
            headerName: 'Review',
            flex: 1.2,
            minWidth: 160,
            cellClassName: 'fw-bold',
            filterColumnName: "review",
            filterType: filterTypeOptions.string,
            renderCell: (params) => {
                const review = params.value;
                if (loading) return <Skeleton width={70} />;

                const words = review ? review.split(" ") : [];
                const preview = words.slice(0, 7).join(" ") + (words.length > 7 ? "..." : "");

                return (
                    <Box sx={{ display: 'flex', gap: '3px', alignItems: 'center', height: '100%' }}>
                        <Typography noWrap sx={{ maxWidth: 200 }}>
                            {preview}
                        </Typography>

                        <Tooltip
                            title={
                                <Box sx={{ maxWidth: 300, maxHeight: 200, overflowY: "auto", whiteSpace: "normal",        // Smooth scrollbar styling
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#bdbdbd",
          borderRadius: "4px",
        }, }}>
                                    <Typography variant="body2">{review}</Typography>
                                </Box>
                            }
                            placement="top"
                            arrow
                        > {
                                preview ? (
                                    <IconButton size="small">
                                        <RemoveRedEyeOutlinedIcon fontSize="small" sx={{ color: '#313030', fontSize: '17px' }} />
                                    </IconButton>
                                ) : (
                                    ''
                                )
                            }
                        </Tooltip>
                    </Box>
                );
            },
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            minWidth: 130,
            filterColumnName: "status",
            filterType: filterTypeOptions.selection,
            selection: reviewStatusList,
            renderCell: (params) =>
                loading ? (
                    <Skeleton width={70} />
                ) : (
                    <Chip
                        label={params.value}
                        size="small"
                        sx={{
                            bgcolor: statusStyles[params.value]?.bg || '#eee',
                            color: statusStyles[params.value]?.text || '#000',
                            fontWeight: 500,
                            textTransform: 'capitalize'
                        }}
                    />
                ),
        },
        {
            field: 'submitted',
            headerName: 'Submitted',
            flex: 1,
            minWidth: 130,
            cellClassName: "fw-bold",
            filterColumnName: "ts",
            filterType: filterTypeOptions.dateRange,

        },
        {
            field: 'action',
            headerName: 'Action',
            filterable: false,
            width: 250,
            renderCell: (params) =>
                loading ? <Skeleton width={80} /> : <Stack direction="row" spacing={1} sx={{ justifyContent: 'start', height: '100%' }}>
                    <Button onClick={() => { setUpdateStatusOpen(true); setSelectedReview(params?.row) }}
                        size="small"
                        variant="outlined" sx={{ border: 'none', textAlign: 'center', minWidth: 'auto', }}
                        startIcon={<DotsIcon />}
                    >

                    </Button>
                </Stack>,
        },

    ];

    return (
        <>
            {/* Apply global styles to DataGrid dropdown menus */}
            {/* <GlobalStyles
                styles={{
                    '.MuiDataGrid-menuList': {
                        fontSize: '13px',
                        padding: '4px 0',
                    },
                    '.MuiDataGrid-panelContent': {
                        fontSize: '13px',
                        padding: '4px 0',
                    },
                    '.MuiSelect-select': {
                        fontSize: '13px',
                        padding: '4px 0',
                    },
                    '.MuiList-root .MuiButtonBase-root': {
                        fontSize: '13px',
                    },
                    '.MuiDataGrid-panelContent .MuiOutlinedInput-input': {
                        fontSize: '13px',
                    },
                    '.MuiDataGrid-columnsManagement .MuiFormControlLabel-root .MuiFormControlLabel-label': {
                        fontSize: '13px',
                    },
                    '.MuiDataGrid-menuList .MuiTypography-root': {
                        fontSize: '13px',
                    },
                    '.MuiDataGrid-menuList .MuiMenuItem-root': {
                        fontSize: '13px',
                        padding: '6px 12px',
                    },
                    '.MuiDataGrid-menuList .MuiMenuItem-root:hover': {
                        backgroundColor: '#f5f5f5',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        position: 'sticky',
                        top: 0,
                        zIndex: 2,
                        backgroundColor: '#fff',
                    },
                    '& .MuiDataGrid-cell.sticky-col-1': {
                        position: 'sticky',
                        left: 0,
                        background: '#fff',
                        zIndex: 2,
                    },
                    '& .MuiDataGrid-columnHeader.sticky-col-1': {
                        position: 'sticky',
                        left: 0,
                        background: '#fff',
                        zIndex: 3, // slightly higher than cell
                    },
                }}
            /> */}

            <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
                <div className="page-header" style={{ position: 'sticky', top: '4.5rem', zIndex: '9', padding: '10px 15px', borderBottom: '1px solid #E6E7E8', background: '#fff', marginBottom: '12px' }}>
                    <div className="row align-items-center">
                        <div className="col">
                            <Typography sx={{ fontSize: '18px', fontWeight: '600', color: '#15243E', display: 'flex', alignItems: 'center', gap: 1, }}><Link href="/university-listing-management" className='d-flex'><BackArrowIcon /></Link>University Review</Typography>
                        </div>
                        {/* End Col */}
                    </div>
                    {/* End Col */}
                </div>
                {/* 
                <Box sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 2,
                    my: 2,
                    px: 2,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}>
                    <Box>
                    </Box>
                    <Button
                        variant="contained"
                        color="#363853"
                        startIcon={<ExportIcon />}
                        onClick={() => console.log("Export clicked")}
                        sx={{
                            background: '#EFEFEF',
                            border: '1px solid #E6E7E8',
                            borderRadius: '8px',
                            textTransform: "none", // Capitalization remove
                            fontWeight: 500
                        }}
                    >
                        Export
                    </Button>
                </Box> */}
                {/* Filter Toolbar */}
                <CommonFilterTab type='reviews-rating' module='web' searchPlaceholder='Search by Name/Mobile...' detailType='Review Overview' fetchList={setSearchFilter} showCount={rows?.length} rowCount={rowCount} />

                {/* Data Table */}
                {/* <CommonTableFormat filteredRows={filteredRows} columns={columns} loading={loading} paginationModel={paginationModel} setPaginationModel={setPaginationModel} rowCount={rowCount} /> */}
                <CommonDataTable columns={columns} rows={rows} idKey="field" loading={loading} filterEnabled={true} rowCount={rowCount}
                    pageFilters={pageFilters}
                    handleFliterSliceChange={handleFliterSliceChange}
                />
            </Box>

            {selectedReview && <UpdateRatingStatusModal refetch={fetchDetails} review={selectedReview} open={updateStatusOpen} onClose={() => setUpdateStatusOpen(false)} />}
        </>
    )
}

export default AdminUniversityRating
